import { Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { ReportBaseService } from './report-base.service';

import { UtilsService } from './utils.service';
import { SalesOrders_DatasourceService } from './SalesOrders.datasource.index';

interface ISalesOrders_pick_slip_by_orderId_reportServiceInParams {
  orderId: number}

interface ISalesOrders_pick_slip_by_orderId_reportServiceData {
  PickSlip?: { result?: { Id?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, MaterialId?: number, Order?: { Id?: number, CreatedSysDateTime?: string, LookupCode?: string, Project?: { Id?: number, LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string } } }, Shipment?: { Id?: number, ExpectedDate?: string, LookupCode?: string, ShippedDate?: string, WaveId?: number, Wave?: { Id?: number, Warehouse?: { Name?: string } }, Carrier?: { Name?: string, ShortName?: string }, Account?: { Name?: string } }, PickSlip?: { Id?: number, LookupCode?: string }, Lot?: { LookupCode?: string }, OrderLine?: { LineNumber?: number, Marks?: string, Notes?: string, Material?: { Id?: number, Description?: string, LookupCode?: string } }, ExpectedPackagedPack?: { Name?: string, ShortName?: string }, ExpectedSourceLicensePlate?: { LookupCode?: string }, ExpectedSourceLocation?: { Name?: string }, MaterialWeights?: { MaterialId?: number, PackagingId?: number, BasePackagingId?: number, BasePackagingQuantity?: number, ShippingWeight?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number }, OrderAddress?: { AttentionOf?: string, FirstName?: string, LastName?: string, Line1?: string, Line2?: string, City?: string, State?: string, PostalCode?: string, Country?: string, PrimaryTelephone?: string, OrderId?: number }, OwnerAddress?: { Id?: number, Project?: { Id?: number, LookupCode?: string, Owner?: { Id?: number, LookupCode?: string, OwnersContactsLookup?: { ContactId?: number, Contact?: { Id?: number, Address?: { City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string } } }[] } } } }[] }
}

@Injectable({ providedIn: 'root' })
export class SalesOrders_pick_slip_by_orderId_reportService extends ReportBaseService<ISalesOrders_pick_slip_by_orderId_reportServiceInParams, ISalesOrders_pick_slip_by_orderId_reportServiceData> {

  protected reportReferenceName = 'pick_slip_by_orderId_report';
  protected appReferenceName = 'SalesOrders';

  constructor(
    $utils: UtilsService,
    private $datasources: SalesOrders_DatasourceService,
    ) {
      super($utils);
  }

  override throwIfMissingRequiredInParams (inParams: ISalesOrders_pick_slip_by_orderId_reportServiceInParams) {
  }

  protected async getData(inParams: ISalesOrders_pick_slip_by_orderId_reportServiceInParams): Promise<ISalesOrders_pick_slip_by_orderId_reportServiceData> 
  {
    const $utils = this.$utils;
    const $report: { inParams: ISalesOrders_pick_slip_by_orderId_reportServiceInParams } = {
      inParams: inParams
    };

    const data: ISalesOrders_pick_slip_by_orderId_reportServiceData = {
    };
    const datasourcesQueries: (() => Promise<void>)[] = [];

    datasourcesQueries.push(async () => {
      const dsParams = {
        orderId:  $report.inParams.orderId 
      };
      
      const dsData = await this.$datasources.SalesOrders.ds_outbound_pick_slip_by_orderId_report.get(dsParams);
      
      data.PickSlip = dsData;
    });

    await Promise.all(datasourcesQueries.map(t => t()));

    return data;
  }
}
